import { Booking } from '../../../../domain/Booking'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Customer } from '../../../../domain/Customer'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-customer',
    templateUrl: './customer.component.html',
})
export class CustomerComponent {

    @Input() customer!: Customer
    @Output() bookingSelected = new EventEmitter<Booking>()
    @Output() customerChanged = new EventEmitter<Customer>()
    tab: 'details' | 'bookings' = 'details'

    constructor(
        private modal: NgbActiveModal
    ) { }

    dismissClicked() {
        this.modal.dismiss()
    }

    detailsTabSelected() {
        this.tab = 'details'
    }

    bookingsTabSelected() {
        this.tab = 'bookings'
    }

    customerUpdated(customer: Customer) {
        this.customer = customer
        this.customerChanged.emit(customer)
    }
}
